<template>
    <v-container class="pt-0" style="background-color: white" fluid>
      <!-- Header -->
      <v-row align="center" justify="center">
        <v-col cols="12" md="auto">
          <div class="d-flex align-center justify-center">
            <v-avatar color="primary" size="44" class="mr-3 elevation-2">
              <v-icon color="white">mdi-account-file-text-outline</v-icon>
            </v-avatar>
            <div>
              <div class="text-h5 font-weight-bold grey--text text--darken-2">Nóminas por Contabilizar</div>
              <div class="text-caption grey--text">Gestión de nóminas pendientes de contabilización</div>
            </div>
          </div>
        </v-col>
      </v-row>

      <!-- Filters -->
      <v-row justify="center">
        <v-col cols="12">
          <search-header-po @dataFilters="get_data($event)" />
        </v-col>
      </v-row>
      <v-card flat class="mt-3" outlined>
        <v-data-table item-key="id" :headers="headers" :items="payrolls_computed" :search="search"  height="55vh" loading-text="Cargando datos..." dense fixed-header :items-per-page="60"
        :footer-props="{
                itemsPerPageText: 'Elementos por página:',
                'items-per-page-text': footerText,
                'page-text': '{0}-{1} de {2}',
                'select-all-text': 'Seleccionar todo',
                'pagination-text': 'Registros'
              }">
          <template v-slot:top>
            <v-toolbar flat>
              <!-- <v-toolbar-title>Nominas</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              {{ payrolls_computed.length }} -->

              <v-spacer> </v-spacer>
              <v-text-field class="mt-3" dense label="Buscar.." v-model="search" append-icon="search" single-line
                hide-details outlined></v-text-field>
              <v-spacer></v-spacer>
              <v-col cols="3">
                  <v-autocomplete  @change="get_payrolls()" v-model="payrolss_accounted" :items="[{ value: 1, text: 'Sin contabilizar' }, { value: 2, text: 'Contabilizadas' }]"
                        label="Estado" outlined dense hide-details></v-autocomplete>
              </v-col>
              <v-col cols="3" v-if="payrolss_accounted==2">
                  <v-autocomplete v-model="billed_filter" :items="[{ value: 'todas', text: 'Todas' }, { value: 'facturadas', text: 'Facturadas' }, { value: 'sin', text: 'Sin facturar' }]"
                        label="Facturación" outlined dense hide-details></v-autocomplete>
              </v-col>
            </v-toolbar>
          </template>
          <template v-slot:[`item.run_code`]="{ item }">
            <a v-if="item.diarybook_id!=null" @click="view_payroll(item)" class="font-weight-medium primary--text" style="cursor:pointer; text-decoration:underline;">{{ item.run_code }}</a>
            <span v-else>{{ item.run_code }}</span>
           </template>
          <template v-slot:[`item.amount`]="{ item }">
            <span>{{ currencyFormat(item.amount) }}</span>
           </template>
          <template v-slot:[`item.invoice_number`]="{ item }">
            <a v-if="item.invoice_id != null" @click="showInvoice(item.invoice_id, true)" class="font-weight-medium primary--text" style="cursor:pointer; text-decoration:underline;">{{ item.invoice_number }}</a>
            <span v-else class="grey--text">-</span>
           </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon :loading="loading && item.id===item_loading" :disabled="loading && item.id!=item_loading" v-if="item.diarybook_id==null"  @click="add_payroll_accounting(item)">
                    <v-icon v-bind="attrs" v-on="on" color="primary">
                        mdi-book-edit-outline
                    </v-icon>
                </v-btn>
              </template>
              <span>Contabilizar</span>
            </v-tooltip>
            <v-menu offset-y v-if="item.diarybook_id!=null">
              <template v-slot:activator="{ on: menu, attrs }">
                <v-btn icon v-bind="attrs" v-on="menu" :loading="loading && item.id===item_loading" :disabled="loading && item.id!=item_loading">
                  <v-icon color="primary">mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item @click="view_payroll(item)">
                  <v-list-item-icon class="mr-3">
                    <v-icon color="success">read_more</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Ver nomina</v-list-item-title>
                </v-list-item>
                <!-- Facturar: genera la factura CxP. Deshabilitada si ya está facturada -->
                <v-list-item @click="confirm_invoice(item)" :disabled="item.invoice_id != null">
                  <v-list-item-icon class="mr-3">
                    <v-icon :color="item.invoice_id != null ? 'grey' : 'primary'">mdi-file-document-plus-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>{{ item.invoice_id != null ? 'Ya facturada' : 'Facturar' }}</v-list-item-title>
                </v-list-item>
                <!-- Una vez facturada NO se permite des/recontabilizar -->
                <v-list-item @click="confirm_remove(item)" :disabled="item.invoice_id != null">
                  <v-list-item-icon class="mr-3">
                    <v-icon :color="item.invoice_id != null ? 'grey' : 'error'">mdi-book-remove-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Descontabilizar nomina</v-list-item-title>
                </v-list-item>
                <v-list-item @click="confirm_reaccount(item)" :disabled="item.invoice_id != null">
                  <v-list-item-icon class="mr-3">
                    <v-icon :color="item.invoice_id != null ? 'grey' : 'warning'">mdi-book-refresh-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Recontabilizar nomina</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
          <template v-slot:no-data>
            <v-row justify="center" class="pt-10">
              <v-icon size="80px">token</v-icon>
            </v-row>
          </template>
        </v-data-table>
            <v-row justify="end" align="center" v-show="payrolss_accounted==2">
                  <v-col cols="12" md="1">
                    <span class="font-weight-bold" style="color: #607d8b; font-size: 15px">
                     TOTAL
                    </span>
                  </v-col>
                    <v-col
                      md="2"
                      align="center"
                    >
                    <th
                      style="font-size: 20px"
                      class="font-weight-bold text-right success--text"
                    >
                     {{payrolls_computed[0]?.currency}} {{ currencyFormat(payrolls_computed.reduce((sum, item) => {return sum + parseFloat(item.amount || 0);}, 0)) }}                      
                    </th>
                  </v-col>
                </v-row>
      </v-card>

      <v-dialog v-model="dialogConfirm" max-width="450">
        <v-card>
          <v-card-title class="text-h6">
            <v-icon :color="actionType=='reaccount' ? 'warning' : 'error'" class="mr-2">mdi-alert-circle-outline</v-icon>
            {{ actionType=='reaccount' ? 'Recontabilizar nómina' : 'Descontabilizar nómina' }}
          </v-card-title>
          <v-card-text>
            <span v-if="actionType=='reaccount'">¿Está seguro que desea recontabilizar esta nómina? Se eliminará su asiento contable actual y se generará uno nuevo.</span>
            <span v-else>¿Está seguro que desea descontabilizar esta nómina? Se eliminará su asiento contable.</span>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialogConfirm=false" :disabled="loading">Cancelar</v-btn>
            <v-btn v-if="actionType=='reaccount'" color="warning" text @click="reaccount_payroll()" :loading="loading">Recontabilizar</v-btn>
            <v-btn v-else color="error" text @click="remove_payroll_accounting()" :loading="loading">Descontabilizar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Facturar nómina -->
      <v-dialog v-model="dialogInvoice" max-width="480">
        <v-card>
          <v-card-title class="text-h6">
            <v-icon color="primary" class="mr-2">mdi-file-document-plus-outline</v-icon>
            Facturar nómina
          </v-card-title>
          <v-card-text v-if="payrollToInvoice">
            Se generará una factura de cuentas por pagar para la nómina
            <b>{{ payrollToInvoice.run_code }}</b>:
            <v-simple-table dense class="mt-3">
              <tbody>
                <tr><td class="grey--text">Monto neto</td>
                  <td class="text-right font-weight-bold">{{ currencyFormat(payrollToInvoice.amount) }} {{ payrollToInvoice.currency }}</td></tr>
                <tr><td class="grey--text">Suplidor (banco)</td>
                  <td class="text-right">{{ payrollToInvoice.bank_description || '—' }}</td></tr>
                <tr><td class="grey--text">Artículo</td>
                  <td class="text-right">Nómina de pago (1257)</td></tr>
              </tbody>
            </v-simple-table>
            <v-alert v-if="!payrollToInvoice.entity_id" type="error" dense text class="mt-3 mb-0">
              El banco de esta nómina no tiene un suplidor/entidad configurado. Asigna
              <b>banks.entity_id</b> antes de facturar.
            </v-alert>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialogInvoice=false" :disabled="invoicing">Cancelar</v-btn>
            <v-btn color="primary" depressed :loading="invoicing"
              :disabled="!payrollToInvoice || !payrollToInvoice.entity_id" @click="invoice_payroll()">
              Facturar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </template>
  <script>
  import moment from "moment";
  export default {
    data: () => ({
      search: null,
      payrolls: [],
      payrolss_accounted:1,
      loading:false,
      item_loading:null,
      dialogConfirm:false,
      actionType:null,
      payrollToRemove:null,
      billed_filter: 'todas',
      dialogInvoice: false,
      payrollToInvoice: null,
      invoicing: false,
      headers: [
        { text: "Run code", value: "run_code" },
        { text: "Planta", value: "location" },
        { text: "Moneda", value: "currency", align: 'center'  },
        { text: "Monto", value: "amount", align: ' d-none'  },
        { text: "Fecha final", value: "pay_date_end_formated" },
        { text: "Factura", value: "invoice_number", align: ' d-none' },
        { text: "Opciones", value: "actions", sortable: false, align: 'center' },
      ],
      filters:null
    }),
    computed: {
      userId() {
        return this.$store.state.auth.user.user.user_id;
      },
      payrolls_computed() {
          let payrolls =[];
          for(let item of this.payrolls){
            item.pay_date_end_formated=moment(item.pay_date_end).format('DD/MM/YYYY');
            item.location=`${item.description_long} (${item.description_short})`;

            payrolls.push(item);
          }
          // Filtro de facturación (solo aplica a contabilizadas).
          if (this.payrolss_accounted == 2 && this.billed_filter != 'todas') {
            payrolls = payrolls.filter((p) =>
              this.billed_filter == 'facturadas' ? p.invoice_id != null : p.invoice_id == null
            );
          }
          return payrolls;
      },
      footerText(){
      return `Nominas: ${this.payrolls_computed.length}`
    },
    },
    mounted() {
    },
     watch: {
        payrolss_accounted(val){
          if(val==1){
            this.headers[3].align=" d-none"; // Monto
            this.headers[5].align=" d-none"; // Factura
          }else{
            this.headers[3].align="center";
            this.headers[5].align="center";
          }
        }
     },
    methods: {
      get_data(filters){
        this.filters=filters;
        this.get_payrolls();
      },
      async get_payrolls() {
        if(this.filters==null){
          return
        }
        const location_access = this.$store.state.auth.locations.map(objeto => objeto.id).join(',');
        const request = await this.api_Post("accounting/get_payrolls_to_be_accounted",{
            locations:location_access,
            accounted:this.payrolss_accounted==2,
            location_id:this.filters?.location,
            business_unit_id:this.filters?.business,
            start_date:this.filters.dateStart,
            end_date:this.filters.dateEnd
            
          });
        this.payrolls = await request.json();
      },
      async add_payroll_accounting(payroll) {
        this.loading=true;
        this.item_loading=payroll.id;
        try {
       
            const request = await this.api_Get("accounting/add_payroll_accounting/"+payroll.id);
            const entryBook = await request.json();
            if (request.status == 200) {
                this.$toast.success("Nomina contabilizada con exito!");
                let index = this.payrolls.indexOf(payroll);
                this.payrolls[index].diarybook_id=entryBook[0].id;
                this.loading=false;
                return
            }
            this.$toast.error("Error al contabilizar la nomina:"+entryBook.error.column);
        } catch (error) {
            this.get_payrolls();
        }
        this.loading=false;
      },
      view_payroll(payroll) {
        let route = this.$router.resolve({name: "ViewEntryPayroll",params: { id: payroll.diarybook_id }, });
        window.open(route.href);
      },
      confirm_remove(payroll) {
        this.payrollToRemove = payroll;
        this.actionType = 'remove';
        this.dialogConfirm = true;
      },
      confirm_reaccount(payroll) {
        this.payrollToRemove = payroll;
        this.actionType = 'reaccount';
        this.dialogConfirm = true;
      },
      async remove_payroll_accounting() {
        const payroll = this.payrollToRemove;
        if (payroll == null) {
          return
        }
        this.loading = true;
        this.item_loading = payroll.id;
        try {
          const request = await this.api_Get("accounting/remove_payroll_accounting/" + payroll.id);
          const data = await request.json();
          if (request.status == 200) {
            this.$toast.success("Nomina descontabilizada con exito!");
            this.dialogConfirm = false;
            this.payrollToRemove = null;
            this.loading = false;
            this.get_payrolls();
            return
          }
          this.$toast.error("Error al descontabilizar la nomina:" + (data?.error?.message || ''));
        } catch (error) {
          this.get_payrolls();
        }
        this.loading = false;
        this.dialogConfirm = false;
      },
      async reaccount_payroll() {
        const payroll = this.payrollToRemove;
        if (payroll == null) {
          return
        }
        this.loading = true;
        this.item_loading = payroll.id;
        try {
          // 1. Descontabilizar
          const removeReq = await this.api_Get("accounting/remove_payroll_accounting/" + payroll.id);
          if (removeReq.status != 200) {
            const removeData = await removeReq.json();
            this.$toast.error("Error al descontabilizar la nomina:" + (removeData?.error?.message || ''));
            this.loading = false;
            return
          }
          // 2. Contabilizar nuevamente
          const addReq = await this.api_Get("accounting/add_payroll_accounting/" + payroll.id);
          const entryBook = await addReq.json();
          if (addReq.status == 200) {
            this.$toast.success("Nomina recontabilizada con exito!");
            this.dialogConfirm = false;
            this.payrollToRemove = null;
            this.loading = false;
            this.get_payrolls();
            return
          }
          this.$toast.error("Error al contabilizar la nomina:" + (entryBook?.error?.column || ''));
        } catch (error) {
          this.get_payrolls();
        }
        this.loading = false;
        this.dialogConfirm = false;
      },
      confirm_invoice(payroll) {
        this.payrollToInvoice = payroll;
        this.dialogInvoice = true;
      },
      // Payload de la factura (igual que prestaciones, pero 1 línea: artículo 1257).
      // Sin accounts[]: la BD genera el asiento automáticamente.
      buildInvoicePayload(item) {
        const date = moment(item.pay_date_end).format("YYYY-MM-DD");
        const time = moment().format("HH:mm:ss");
        const description = `Nómina de pago ${item.run_code}`;
        return {
          in_invoice_id: null,
          in_category_id: 2,
          in_type_id: 4,
          in_voucher_type_id: null,
          in_business_unit_id: item.business_unit_id,
          in_location_id: item.location_id,
          in_department_id: null,
          in_entity_id: item.entity_id, // banks.entity_id (banco a donde se envió la nómina)
          in_responsable_entity_id: null,
          in_entity_branch_id: null,
          in_created_by: this.userId,
          in_effective_date: `${date} ${time}`,
          in_account_date: `${date} ${time}`,
          in_expire_at: date,
          in_currency_id: item.currency_id,
          in_currency_rate: 1,
          in_note: description,
          in_box_entry_id: null,
          in_order_entry_id: null,
          in_ncf_invoice_id: null,
          in_discount: 0,
          in_tip: 4,
          in_invoice_vouchers: [],
          in_payments: [],
          in_entity_payments: [],
          in_withholdings: [],
          in_supplier_details: { supplier_invoice_number: item.run_code, supplier_invoice_voucher: null },
          in_items: [{
            withholding_id: null,
            withholding_amount: 0,
            item_id: 1257,
            order_entry_id: null,
            item_description: description,
            quantity: 1,
            tax_id: 1,
            price: Number(item.amount) || 0,
            warehouse_id: null,
            item_chart_of_account_id: null,
            discount: 0,
            cost: 0,
            unit_id: 38,
            // Enviamos la contabilidad: la función usa esto y NO la categoría del
            // artículo. Débito a la cuenta 42 (21310001 Acumulado por Pagar -
            // Salario y Nómina); el crédito a Cuentas por Pagar lo genera la
            // función desde el suplidor (in_entity_id).
            accounts: [{
              chart_of_account_id: 42,
              entry_type_id: 1,   // débito (price > 0)
              account_type_id: 1,
              location_id: item.location_id,
              dgii_category_id: null,
              department_id: null,
              category_id: null,
              subcategory_id: null,
              amount: Number(item.amount) || 0,
            }],
            note: description,
            is_inventoriable: false,
          }],
          is_bussiness: true,
          in_installments: null,
          in_quotation_id: null,
          others_settings: { status_order_id: null, metadata: {} },
        };
      },
      async invoice_payroll() {
        const item = this.payrollToInvoice;
        if (!item || !item.entity_id) return;
        this.invoicing = true;
        this.item_loading = item.id;
        try {
          const response = await this.api_Post("income/invoice_register", this.buildInvoicePayload(item));
          const result = await response.json();
          const invoice = Array.isArray(result) ? result[0] : result;
          if (response.status != 200 || !invoice || !invoice.id) {
            this.$toast.error("Error al generar la factura" + (result?.error?.message ? ": " + result.error.message : ""));
            this.invoicing = false;
            return;
          }
          // Vincular la factura a la nómina.
          await this.api_Post("accounting/set_payroll_invoice", { payroll_schedule_id: item.id, invoice_id: invoice.id });
          item.invoice_id = invoice.id;
          item.invoice_number = invoice.invoice_number;
          this.$toast.success("Nómina facturada con éxito!");
          this.dialogInvoice = false;
        } catch (error) {
          console.error(error);
          this.$toast.error("Error al facturar la nomina");
        }
        this.invoicing = false;
      }
    },
  };
  </script>